/**
 * Stats Block JavaScript
 */

(function() {
    'use strict';
    
    // Initialize block functionality
    function initStats() {
        const blocks = document.querySelectorAll('.stats');
        
        blocks.forEach(block => {
            // Add your block functionality here
            console.log('[BLOCK] stats block initialized');
        });
    }
    
    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initStats);
    } else {
        initStats();
    }
})();